import countries, { getCountryCodeByString } from '~/glm/utils/countries';
import { getStateAbbreviationByString } from '~/glm/utils/us-states';
import { safeTrim } from '~/glm/utils/strings.js';

function countryNameLookup(abbreviation) {
  const country = countries.find(c => c.abbreviation === abbreviation);
  return country ? country.name : '';
}

function isValidAddress(address) {
  if (!address) return false;
  const validateFields = ['street1', 'street2', 'city', 'zip', 'state', 'country'];
  const addressKeys = Object.keys(address);
  const passedFields = validateFields.filter(
    value => !(value === 'country' && address[value] === 'US') && addressKeys.indexOf(value) !== -1
  );
  return passedFields.some(key => address[key] && address[key].length >= 1);
}

function validMailingAddress(address = {}) {
  const validateFields = ['street1', 'city', 'zip', 'state'];
  return validateFields.every(e => address[e] && address[e].length > 0);
}

function temp_isValidAddress(address) {
  if (!address) return false;
  const validateFields = ['street1', 'street2', 'city', 'zip', 'state', 'country'];
  const addressKeys = Object.keys(address);
  const passedFields = validateFields.filter(
    value => !(value === 'country' && address[value] === 'US') && addressKeys.indexOf(value) !== -1
  );
  return passedFields.some(key => address[key] && address[key].length >= 1);
}

function temp_validMailingAddress(address = {}) {
  const validateFields = ['street1', 'city', 'zip', 'state'];
  return validateFields.every(e => address[e] && address[e].length > 0);
}

function isAddressParseable(rawAddress = {}, fullAddress = '') {
  return !isValidAddress(rawAddress) && fullAddress.length > 0;
}

function fullAddressString(addressObject) {
  const { street1, street2, city, zip, state } = addressObject;
  return [street1, street2, city, zip, state].filter(Boolean).join(', ');
}

function sanitizedAddress(addressObject) {
  const { street1, street2, city, zip, state, country, fullAddress = '' } = addressObject;
  if (fullAddressString(addressObject).length === 0 && fullAddress.length === 0) {
    return undefined;
  }

  return {
    street1: safeTrim(street1) || undefined,
    street2: safeTrim(street2) || undefined,
    city: safeTrim(city) || undefined,
    zip: safeTrim(zip) || undefined,
    state: getStateAbbreviationByString(safeTrim(state)) || undefined,
    country: getCountryCodeByString(safeTrim(country)) || undefined,
    fullAddress: safeTrim(fullAddress) || undefined,
  };
}

export {
  isAddressParseable,
  countryNameLookup,
  isValidAddress,
  validMailingAddress,
  temp_isValidAddress,
  temp_validMailingAddress,
  sanitizedAddress,
};
